import { GET_NOTIFICATION_LIST_ACTION_TYPE,READ_NOTIFICATION_ACTION_TYPE } from "../../utils/constants";

const initialState = {
    notificationList: null,
};

function notificationReducer(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case GET_NOTIFICATION_LIST_ACTION_TYPE:
            return { ...state, notificationList: payload };
        case READ_NOTIFICATION_ACTION_TYPE:
            return { ...state, notificationList: payload };
        default:
            return state;
    }
}

export default notificationReducer;
